import { IconProps } from '@assets/types';
import { FC } from 'react';

export const NumberSymbolGold: FC<IconProps> = ({
  width = 15,
  height = 12,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M-0.0034374 11.4241V7.15256e-05H1.61256L6.81256 9.40807H6.87656C6.8659 9.13074 6.8499 8.81074 6.82856 8.44807C6.80723 8.08541 6.79123 7.72274 6.78056 7.36007C6.7699 6.98674 6.76456 6.66674 6.76456 6.40007V7.15256e-05H8.02856V11.4241H6.46056L1.19656 1.98407H1.13256C1.1539 2.26141 1.1699 2.59207 1.18056 2.97607C1.2019 3.34941 1.2179 3.72274 1.22856 4.09607C1.2499 4.46941 1.26056 4.80007 1.26056 5.08807V11.4241H-0.0034374ZM9.54856 11.4241V10.3201H13.6606V11.4241H9.54856ZM11.5966 9.28007C11.1379 9.28007 10.7272 9.17874 10.3646 8.97607C10.0126 8.76274 9.73523 8.45341 9.53256 8.04807C9.3299 7.64274 9.22856 7.14674 9.22856 6.56007C9.22856 5.68541 9.4419 5.01874 9.86856 4.56007C10.3059 4.09074 10.8979 3.85607 11.6446 3.85607C12.1032 3.85607 12.5086 3.96274 12.8606 4.17607C13.2232 4.37874 13.5059 4.68274 13.7086 5.08807C13.9219 5.48274 14.0286 5.97341 14.0286 6.56007C14.0286 7.43474 13.8099 8.10674 13.3726 8.57607C12.9352 9.04541 12.3432 9.28007 11.5966 9.28007ZM11.6286 8.35207C12.0979 8.35207 12.4339 8.20274 12.6366 7.90407C12.8392 7.59474 12.9406 7.14674 12.9406 6.56007C12.9406 5.96274 12.8392 5.52541 12.6366 5.24807C12.4339 4.96007 12.0979 4.81607 11.6286 4.81607C11.1699 4.81607 10.8339 4.96007 10.6206 5.24807C10.4072 5.52541 10.3006 5.96274 10.3006 6.56007C10.3006 7.14674 10.4019 7.59474 10.6046 7.90407C10.8179 8.20274 11.1592 8.35207 11.6286 8.35207Z"
        fill="url(#paint0_linear_4194_9909)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4194_9909"
          x1={6.63281}
          y1={16.4241}
          x2={6.63281}
          y2={-4.57593}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset={0.0720001} stopColor="#DFB066" />
          <stop offset={0.152} stopColor="#EDDEA5" />
          <stop offset={0.242} stopColor="#F3C962" />
          <stop offset={0.347} stopColor="#FAD682" />
          <stop offset={0.485} stopColor="#FFE8B2" />
          <stop offset={0.652} stopColor="#D99D51" />
          <stop offset={0.802} stopColor="#D69C4D" />
          <stop offset={1} stopColor="#F0DFA7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
